// ==========================================================================
// Accordion initializer / controller singleton
// ==========================================================================

class Accordion {
  constructor() {
    this.init = this.init.bind(this);
  }

  init() {
    const containers = [
      ...document.querySelectorAll('.js-accordion-container'),
    ];
    if (containers) {
      containers.map(container => {
        if (container.value !== 'initialized') {
          container.value = 'initialized';
          this._bindAccordion(container);
        }
      });
    }
  }

  _bindAccordion(container) {
    const control = container.querySelector('.js-accordion-control');
    const target = container.querySelector('.js-accordion-target');

    control.addEventListener('click', event => {
      event.preventDefault();
      if (!control.matches('.accordion-open')) {
        control.classList.add('accordion-open');
        target.classList.add('accordion-open');
      } else {
        control.classList.remove('accordion-open');
        target.classList.remove('accordion-open');
      }
    });
  }
}

export const accordion = new Accordion();



// WEBPACK FOOTER //
// ./src/js/accordion.js